export default __webpack_public_path__ + "static/media/invoice-logo.32a7189b.png";